// Link URLs are typed by profile owners and rendered as hrefs for every
// visitor, so anything that is not a web, mail or phone link must never reach
// the DOM as-is (React 16 still renders `javascript:` hrefs). The server
// normalizes new links the same way (normalizeLinkUrl in routes/user.js); this
// also covers links saved before that existed, many of which were stored
// without a scheme and so opened as a path on this site.
const SAFE_SCHEME = /^(https?:|mailto:|tel:)/i;

const safeHref = (raw) => {
  const url = String(raw === undefined || raw === null ? '' : raw).trim();
  if (!url) return undefined;
  if (SAFE_SCHEME.test(url)) return url;
  if (url.indexOf('//') === 0) return 'https:' + url;
  if (/^[^\s@/:]+@[^\s@/:]+\.[^\s@/:]+$/.test(url)) return 'mailto:' + url;
  // Prefixing makes any other scheme (javascript:, data:, …) part of a host
  // name, which is harmless.
  return 'https://' + url;
};

export default safeHref;
